import { EntityState, EntityType } from './apiTypes.model'

export enum ChannelType {
  Directo = 'directo',
  OperadorOnline = 'operador_online',
  OperadorTradicional = 'operador_tradicional'
}

export interface ChannelAuxList {
  advance: number
  cachedChannel: boolean
  channelHotel: boolean
  channelOwner: boolean
  channelType: ChannelType
  channelWeb: boolean
  comissionIncludeVat: boolean
  controlChannel: boolean
  entityState: EntityState
  entityType: EntityType.ChannelAuxList
  environmentDataId: string
  id: string
  includeVat: boolean
  name: string
  netPrice: boolean
  turboSuite: boolean
  update: boolean
  channelManagerId?: string
  daysToSynchronize?: number
  synchronizeToDate?: string
  lastSyncDate?: string
  address?: string
  cif?: string
  city?: string
  email?: string
  phone?: string
  postalCode?: string
  source?: string
  hideInSelect: boolean
  inherited: boolean
}
